const removeDupeQueries = (results) => {
  const newResults = results
  if (!results || !results.pages) {
    return
  }
  const seen = {}
  const newPages = results.pages.map((page) =>
    page.filter((suggestedSearch) => {
      if (seen[suggestedSearch.query]) {
        return false
      }
      seen[suggestedSearch.query] = true
      return true
    }),
  )

  newResults.pages = newPages
}

export default removeDupeQueries
